// extracted by mini-css-extract-plugin
module.exports = {"date":"CreditTransactionList_date__1LRHP"};